import { Provider } from "react-redux";
import { AppRouter } from './routers/AppRouter';
import { store } from './store/store';
import { AppState } from "./components/AppState";
import GTMNoScript from "./components/GTMNoScript";

export const App = () => {

  return (

    <AppState>

      <Provider store={store}>

        <GTMNoScript />

        <AppRouter />

      </Provider>

    </AppState>
    
  );
}


